"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconTick', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M11.2525 7.15852C11.6162 6.74288 11.5741 6.11112 11.1584 5.74744C10.7428 5.38375 10.111 5.42587 9.74736 5.84151L7.26344 8.68028L5.74226 7.1591C5.35174 6.76858 4.71857 6.76858 4.32805 7.1591C3.93753 7.54963 3.93753 8.18279 4.32805 8.57332L6.60504 10.8503C6.80075 11.046 7.06881 11.1519 7.34543 11.1426C7.62204 11.1334 7.88247 11.01 8.06473 10.8017L11.2525 7.15852Z', 'M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z', 'M14.6402 6.23173C15.0645 6.58529 15.1218 7.21586 14.7682 7.64014L9.76822 13.6401C9.57978 13.8663 9.30129 13.9979 9.00694 13.9999C8.7126 14.002 8.43231 13.8742 8.24074 13.6507L5.24074 10.1507C4.88132 9.73142 4.92988 9.10012 5.34921 8.74069C5.76853 8.38127 6.39983 8.42983 6.75926 8.84916L8.98924 11.4508L13.2318 6.35977C13.5853 5.93549 14.2159 5.87817 14.6402 6.23173Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z', 'M17.6 7.19996C18.0418 7.53133 18.1314 8.15813 17.8 8.59996L11.8 16.6C11.6199 16.8401 11.3415 16.9866 11.0416 16.9991C10.7417 17.0116 10.452 16.8887 10.2526 16.6643L6.25259 12.1643C5.88567 11.7515 5.92285 11.1195 6.33564 10.7526C6.74842 10.3856 7.38049 10.4228 7.74741 10.8356L10.9343 14.4209L16.2 7.39996C16.5314 6.95813 17.1582 6.86859 17.6 7.19996Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M24.1869 10.9171C24.6935 10.2616 24.5727 9.31956 23.9172 8.81302C23.2617 8.30648 22.3196 8.42726 21.8131 9.08278L14.3553 18.734L10.0607 14.4393C9.47487 13.8535 8.52513 13.8535 7.93934 14.4393C7.35355 15.0251 7.35355 15.9748 7.93934 16.5606L13.4393 22.0606C13.7442 22.3654 14.1654 22.5244 14.5956 22.4969C15.0258 22.4694 15.4233 22.2582 15.6869 21.9171L24.1869 10.9171Z', 'M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16ZM28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;